import styles from './styles.module.scss';

export default function Card({ name, editar, destroy, id, publico, publicar, privar }) {
    return (
        <div className={styles.card}>
            <p>{name}</p>
            <p className={`${styles.visibilidade} ${publico ? styles.publico : styles.privado}`}>
                {publico ? (
                    <>
                        {' '}
                        <span>Público </span>
                        <span className='material-symbols-outlined'>public</span>{' '}
                    </>
                ) : (
                    <>
                        <span>Privado </span>
                        <span className='material-symbols-outlined'>vpn_lock</span>
                    </>
                )}
            </p>
            <button
                onClick={publico ? privar : publicar}
                className={`${styles.edit} ${publico ? styles.publico : styles.privado}`}
            >
                {publico ? 'Privar ' : 'Publicar'}
            </button>
            <button onClick={editar} className={styles.edit}>
                Editar
            </button>
            <button onClick={() => destroy(id)} className={styles.deletar}>
                <span style={{ color: 'white' }} className='material-symbols-outlined'>
                    delete
                </span>
            </button>
        </div>
    );
}
